import React from 'react';

import { PanelContext, type PanelContextInterface } from '../context/PanelContext';

const usePanel = (): PanelContextInterface => React.useContext(PanelContext);

export default usePanel;
